
import React from 'react';
import { Link } from "react-router-dom";
import { Logo } from "./header/Logo";
import { UserNav } from "./header/UserNav";
import { SubscriptionBadge } from "@/components/subscription/SubscriptionBadge";

interface AuthenticatedHeaderProps {
  userName: string;
  showHistory: boolean;
}

export const AuthenticatedHeader: React.FC<AuthenticatedHeaderProps> = ({ userName, showHistory }) => {
  return (
    <header className="border-b h-14 px-4 md:px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <SubscriptionBadge />
        <UserNav userName={userName} />
      </div>
    </header>
  );
};
